export default "__VITE_ASSET__BUE7dwXj__"